import React from "react";
import parse from "html-react-parser";
import { Success } from "../../common/icons";

function SuccessComponent({ message }) {
  return (
    <div className="validation-success p-3">
      <div className="mr-2">
        <Success />
      </div>
      <div> {parse(message)} </div>
    </div>
  );
}

export default SuccessComponent;
